module.exports = __webpack_public_path__ + "img/iraq.2a6014aa.svg";